var _defs, _path, _path2, _path3, _path4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 36.44 36.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ico-1,.ico-2{fill:#7c2e2c;}.ico-1,.ico-4{fill-rule:evenodd;}.ico-3{fill:url(#ico-gradient);}.ico-5{fill:#9b2f2d;}.ico-4{fill:url(#ico-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ico-gradient",
    x1: 24.29,
    y1: 1063.01,
    x2: 31.88,
    y2: 1076.15,
    gradientTransform: "translate(0 -1040.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#a72f2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#bb2e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#d82a2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d82a2c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ico-gradient-2",
    x1: 9.61,
    y1: 1040.68,
    x2: 9.61,
    y2: 1077.41,
    gradientTransform: "translate(0 -1040.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d82a2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#d42a2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#c72c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#b32e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#a72f2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ac2f2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#bb2e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#d82a2c"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ico-1",
    d: "M8.41,30c-1.88-1.36.28-4.08.28-4.08,1.08-1.27,4.84-4.83,4.84-4.83h0C21.06,14.69,18.93,0,18.93,0c-.05,12.46-7.63,17.42-7.63,17.42a99.17,99.17,0,0,1-8,5.94C-1.95,27.75.63,32.94.63,32.94c2.5,4.92,6.88,3.64,6.88,3.64,6.67-1.8,9.59-9.8,9.59-9.8A14.37,14.37,0,0,1,12.65,30,4.18,4.18,0,0,1,8.41,30Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ico-2",
    d: "M32.45,24.06l-4.23-2.51-.46-.34a14,14,0,0,1-5.39-8.9c-.08-.41-.15-.82-.23-1.22-.07.05-.09.08-.09.12a57.92,57.92,0,0,0-.32,6.45,6.82,6.82,0,0,0,.27,1.9,9.74,9.74,0,0,0,3.38,4.79c1.17,1,2.48,1.75,3.71,2.63a6.59,6.59,0,0,1,1.55,1.38,1.91,1.91,0,0,1,.14,2.3,2.45,2.45,0,0,1-1.34,1c-.25.09-.5.16-.74.23h.17a5.23,5.23,0,0,1-3.17-.65,16.87,16.87,0,0,1-4.16-3.79s-.83-1.36-3.44-1.55c0,0,1.73,5.42,5.73,8.3a8.16,8.16,0,0,0,8.36,1.07s3.65-1.68,4.16-4.91C36.35,30.36,37.35,27,32.45,24.06ZM29.86,31.8l.36-.05-.07,0A2.58,2.58,0,0,1,29.86,31.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ico-3",
    d: "M28.05,21.45s4.54,4.27,4.62,6.53a3.21,3.21,0,0,1-2.52,3.79,3.85,3.85,0,0,1-.69.06s-2.37.4-3.76-.59a16.87,16.87,0,0,1-4.16-3.79s-.83-1.36-3.44-1.55c0,0,1.73,5.42,5.73,8.3a8.16,8.16,0,0,0,8.36,1.07s3.65-1.68,4.16-4.91c0,0,1-3.39-3.9-6.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ico-4",
    d: "M18.93,0s2.18,15-5.63,21.3L7.86,26.24S4.2,29.77,5.31,31.75c.51.92,1.47,2.11,3.94,1.53,0,0,2.26-.41,7.85-6.5,0,0-2.92,8-9.59,9.8,0,0-4.38,1.28-6.88-3.64,0,0-2.58-5.19,2.67-9.58a99.17,99.17,0,0,0,8-5.94S18.88,12.46,18.93,0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ico-5",
    x: 16.49,
    y: 31.56,
    width: 2.89,
    height: 2.89,
    transform: "translate(-18.09 22.35) rotate(-45)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.d8946ac98950e7512790705d596161d3.svg";
export { ForwardRef as ReactComponent };